import md5 from "blueimp-md5"; 
import axios from "axios";
export async function encrypteParams(data = {}) {
  let timestamp;
  try {
    timestamp = await getTimestamp(data.timeParam);
  } catch (e) {
    timestamp = e;
  }
  const nonce = getNonce();
  data.api_sign = getSign(data, timestamp, nonce);
  data.api_timestamp = timestamp;
  data.api_nonce = nonce;
  return data;
}

export async function urlParams(data = {}) {
  const codeName = sessionStorage.getItem("tenantCodeName");
  if (codeName) {
    data = {
      ...data,
      tenant_code: sessionStorage.getItem("tenantCodeName")
    };
  }
  let timestamp;
  try {
    timestamp = await getTimestamp(data.timeParam);
  } catch (e) {
    timestamp = e;
  }
  const nonce = getNonce();
  const sign = getSign(data, timestamp, nonce);
  const tenantCode = codeName ? "&tenant_code=" + codeName : "";
  return `?api_sign=${sign}&api_timestamp=${timestamp}&api_nonce=${nonce}${tenantCode}`;
}
//
// 获取客户端时间戳
function getTimestamp(timeParam = 'platform-login') {
  return new Promise((resolve, reject) => {
    // resolve(new Date().getTime())
    axios
      .post(
        `/${timeParam || 'platform-login'}/system/getTimestamp.jsonx?tenant_code=` +
          sessionStorage.getItem("tenantCodeName"),
        {}
      )
      .then(res => {
        resolve(res.data.data || new Date().getTime());
      })
      .catch(res => {
        reject(new Date().getTime());
      });
  });
}

// 获取客户端随机数
function getNonce() {
  function s4() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  }
  return s4() + s4() + s4() + s4() + s4() + s4() + s4() + s4();
}

// 获取客户端签名
function getSign(params, timestamp, nonce) {
  params.api_timestamp = timestamp;
  params.api_nonce = nonce;
  // 递归排序编码
  let encodeStr = recursiveSortAndEncrypt(params);
  // 进行字符加密
  return md5(encodeStr);
}

// 递归排序编码
function recursiveSortAndEncrypt(obj) {
  let result = "";

  if (obj !== null) {
    if (isJSONObject(obj)) {
      // 字典排序
      let keys = Object.keys(obj).sort();

      // 遍历对象
      for (let i = 0; i < keys.length; i++) {
        let key = keys[i];
        let value = recursiveSortAndEncrypt(obj[key]);

        // 排除空字符串
        if (null !== value && "" !== value && value !== "undefined") {
          result += key + value;
        }
      }
    } else if (isJSONArray(obj)) {
      // 遍历对象
      if (0 != obj.length) {
        // 排除空数组
        for (let i = 0; i < obj.length; i++) {
          result += recursiveSortAndEncrypt(obj[i]);
        }
      }
    } else {
      result += encode(obj);
    }
  }

  return result;
}

// 特殊处理符号
function encode(obj) {
  return encodeURIComponent(obj)
    .replace(/!/g, "%21") // 感叹号
    .replace(/`/g, "%60") // 顿号
    .replace(/\(/g, "%28") // 左括号
    .replace(/\)/g, "%29") // 右括号
    .replace(/~/g, "%7E") // 波浪号
    .replace(/\'/g, '%27') // 单引号
}

// 判断是否为JSON对象
function isJSONObject(obj) {
  let result = false;
  if (obj) {
    let jsonStr = JSON.stringify(obj);
    jsonStr = jsonStr.replace(/\s/g, "").replace(/\n|\r/, "");
    if (/^\{(.*?)\}$/.test(jsonStr)) {
      if (jsonStr === "{}") {
        result = true;
      } else {
        result = /"(.*?)":(.*?)/g.test(jsonStr);
      }
    }

    if (/^\[(.*?)\]$/.test(jsonStr)) {
      if (jsonStr === "[]") {
        result = true;
      }
      const strs = jsonStr.replace(/^\[/, "").replace(/\]$/, "");
      try {
        // return jsonStr
        //   .replace (/^\[/, '')
        //   .replace (/\]$/, '')
        //   .replace (/},{/g, '}\n{')
        //   .split (/\n/)
        // .map (function (s) {
        //   if (s) result = isJSONObject (JSON.parse (s));
        // })
        // .reduce (function (prev, curr) {
        //   result = !!curr;
        // });
        return JSON.parse(jsonStr)
          .map(function(s) {
            if (s) result = isJSONObject(s);
          })
          .reduce(function(prev, curr) {
            result = !!curr;
          });
      } catch (err) {
        if (strs) isJSONObject(JSON.parse(strs));
      }
    }
  }
  return result;
}

// 判断是否为JSON数组
function isJSONArray(obj) {
  let result = true;

  if (Array.isArray(obj)) {
    for (let i = 0; i < obj.length; i++) {
      if (!isJSONObject(obj[i])) {
        result = false;
        break;
      }
    }
  } else {
    result = false;
  }

  return result;
}
export function decodeHtml(value) {
    if (!value) return value;
    return value;
  //   value = value.replace(/&amp;/g,"&");
  //   value = value.replace(/&lt;/g,"<");
  //   value = value.replace(/&gt;/g,">");
  //   value = value.replace(/&nbsp;/g," ");
  //   value = value.replace(/&quot;/g,"\"");
  //   value = value.replace(/&ldquo;/g,"\“");
  //   value = value.replace(/&rdquo;/g,"\”");
  }



// WEBPACK FOOTER //
// ./src/common/js/encryption.js